const licenseTypes = {
  enterprise: 'Enterprise',
  seat: 'Seat',
  site: 'Site'
};

export default licenseTypes;
